import { generateKeyPair, exportJWK, importJWK, SignJWT } from "jose";
import sm from "../utils/storageManager";

class DPoPService {
  private privateKey: CryptoKey | null = null;
  private publicJwk: JsonWebKey | null = null;

  private initializing: Promise<void> | null = null;

  private ensureKeyPair = async () => {
    if (this.privateKey && this.publicJwk) {
      return;
    }

    if (this.initializing) {
      await this.initializing;
      return;
    }

    this.initializing = (async () => {
      const storedPrivateJwk = await sm.getIndexedDB("dpop_private_jwk");
      if (
        storedPrivateJwk &&
        storedPrivateJwk.publicJwk &&
        storedPrivateJwk.privateKey
      ) {
        this.publicJwk = storedPrivateJwk.publicJwk;
        this.privateKey = storedPrivateJwk.privateKey;
        this.initializing = null;
        return;
      }

      const { publicKey, privateKey } = await generateKeyPair("ES256");

      this.privateKey = privateKey;
      this.publicJwk = await exportJWK(publicKey);

      await sm.setIndexedDB("dpop_private_jwk", {
        publicJwk: this.publicJwk,
        privateKey: this.privateKey,
      });

      this.initializing = null;
    })();

    await this.initializing;
  };

  public getPublicJwk = async () => {
    await this.ensureKeyPair();
    return this.publicJwk;
  };

  private createDPoPProof = async (httpMethod: string, httpUrl: string) => {
    await this.ensureKeyPair();

    const htm = httpMethod.toUpperCase();
    const htu = new URL(httpUrl, window.location.origin).toString();

    const jwt = await new SignJWT({
      htm,
      htu,
      iat: Math.floor(Date.now() / 1000),
      jti: crypto.randomUUID(),
    })
      .setProtectedHeader({
        alg: "ES256",
        typ: "dpop+jwt",
        jwk: this.publicJwk!,
      })
      .sign(this.privateKey!);

    return jwt;
  };

  public getAjaxOptions = async (
    httpMethod: string,
    httpUrl: string,
    securityHeaders: any
  ) => {
    return {
      DPoP: await this.createDPoPProof(httpMethod, httpUrl),
      ...securityHeaders,
    };
  };
}

const instance = new DPoPService();
export default instance;
